export const MARKDOWN_HEADER_REGEX = /^(#{1,6})\s+(.+)$/gm
export const MARKDOWN_UNDERLINE_HEADER_REGEX = /^([^\r\n]+)\r?\n([=\-])\2+\s*$/gm
